/* eslint-disable no-unused-vars */
import img from '../img/exitbacklog2dates.svg';

export default {
  id: 'exitbacklog2dates',
  img,
  imgBg: 'linear-gradient(to right, #E6DAFF 0%, #E6DAFF 50%, #FFDDBC 50%, #FFDDBC 100%)',
  defaultConf() {
    return {
      duration: 'week',
    };
  },
  confOptions: {
    duration: ['day', 'week', 'month'],
  },
  canRun({ planning, element, oldData, newData, automation }) {
    return ! oldData.processStep && newData.processStep;
  },
  run({ planning, element, oldData, newData, automation }, showToast) {
    const start = element.getStartTime();
    const end = element.getEndTime();
    if (start && end) return;
    const unit = automation.conf?.duration;
    if (! this.confOptions.duration.includes(unit)) return;

    if (showToast) showToast();
    const workdays = planning.visibleTimeline?.workdays;
    const computedStart = start || (end ? end.clone().addWithWorkdays(-1, unit, workdays) : moment());
    const computedEnd = end || computedStart.clone().addWithWorkdays(1, unit, workdays);

    if (! start) element.setStartTime(computedStart);
    if (! end) element.setEndTime(computedEnd);
  },
};
